<style>
  .tooltip {
    border: 1px solid #ddd;
    box-shadow: 1px 1px 1px #ddd;
    background: white;
    border-radius: 4px;
    padding: 4px;
    position: absolute;
  }
</style>

<script lang="ts">
  import type { PriceAlert, Race, Runner } from '$types/races';
  import { createEventDispatcher } from 'svelte';
  import TablerTrash from '~icons/tabler/trash';

  export let alert: PriceAlert;
  export let race: Race;

  let hoveredBookmaker = '';

  //   map the runnerId to the runner object
  let runner: Runner | undefined;
  $: {
    if (alert.runnerId) {
      runner = (race?.runners ?? []).find((r) => r.id === alert.runnerId);
    }
  }

  const getTriggerShorthand = () => {
    switch (alert.alertType) {
      case 'GREATER_THAN':
        return '>';
      case 'LESS_THAN':
        return '<';
      case 'GREATER_THAN_OR_LESS_THAN':
        return '<>';
    }
  };

  const dispatch = createEventDispatcher();
  const handleEdit = () => {
    dispatch('edit', alert);
  };
  const handleDelete = () => {
    dispatch('delete', alert.id);
  };
</script>

<li>
  <div
    class="flex items-center space-x-4 bg-gray-50 p-1 px-2 text-sm text-gray-800"
  >
    <div class="flex min-w-0 flex-1 flex-row">
      <div class="flex-col">
        <div class="flex flex-row items-center">
          {#if runner}
            <span class="font-semibold">
              {runner?.number}. {runner?.name}
            </span>
          {/if}
        </div>
        {#if alert.bookmakers}
          <div class="flex flex-row items-center">
            {#if alert.bookmakers.length > 1}
              {#each alert.bookmakers.slice(0, 5) as alertBookmaker}
                <div
                  role="tooltip"
                  class="bookmaker-{alertBookmaker
                    .toLowerCase()
                    .replace(' ', '')} mr-1 h-3 w-3 rounded-full"
                  on:mouseenter={() => {
                    hoveredBookmaker = alertBookmaker;
                  }}
                  on:mouseleave={() => {
                    hoveredBookmaker = '';
                  }}
                />
              {/each}
              {#if alert.bookmakers.length > 5}
                ...
              {/if}
              {alert.bookmakers.length} bookmakers
            {:else}
              <div
                class="bookmaker-{alert.bookmakers[0]
                  .toLowerCase()
                  .replace(' ', '')} mr-1 h-3 w-3 rounded-full"
              />
              {alert.bookmakers[0]}
            {/if}
          </div>
          {#if hoveredBookmaker}
            <div
              id="tooltip-{alert.id}-{hoveredBookmaker}"
              class="absolute z-50 flex max-h-72 flex-col overflow-y-auto rounded-sm border border-gray-200 bg-white px-1 py-1 text-xs font-normal shadow-sm shadow-gray-300"
            >
              {hoveredBookmaker}
            </div>
          {/if}
        {/if}
      </div>
    </div>
    <div
      class="flex w-12 flex-col items-center justify-center rounded-md bg-slate-200 p-2 text-center font-mono leading-none"
    >
      <span class="text-[8px]"
        >{alert?.priceType === 'FIXED_WIN' ? 'FW' : 'FP'}</span
      >
      <span class="text-[10px]">{getTriggerShorthand()}</span>
      <span class="text-xs font-semibold">{alert.value}</span>
      <!-- <span class="text-[10px]">±0%</span> -->
    </div>
    <div class="flex flex-col">
      <!-- <div class="cursor-pointer text-slate-300 hover:text-slate-500">
          <EditIcon />
        </div> -->
      <button
        class="cursor-pointer text-red-300 hover:text-red-500"
        on:click={handleDelete}
        on:keypress={handleDelete}
      >
        <TablerTrash />
      </button>
    </div>
  </div>
</li>
